import React from "react"
import { useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router"
import { LicensesSet, User } from "../../../mp-database"
import { Roles } from "../../../mp-utils/generic-utils"
import { useLicenseStatus } from "../../../mp-utils/ready-utils"
import { RootState } from "../../redux/store"
import TopBanner from "../TopBanner"

interface Props {
  userLicenses: LicensesSet[]
}

const GoToCurrentVersionBannerContainer: React.FC<Props> = ({
  userLicenses
}) => {
  const { user } = useSelector((state: RootState) => ({
    user: state.users.testUser as User
  }))

  const history = useHistory()
  const location = useLocation()

  // Use the hook directly to ensure we always have the values
  const { hasOnlyACTLegacyLicenses, hasACTAndOtherLicenses } =
    useLicenseStatus(userLicenses)

  const isTakingOrReviewingTestOrLesson =
    location.pathname.includes("test-taking") ||
    location.pathname.includes("/snap/student") ||
    location.pathname.includes("elements")

  const showPreviousVersionBanner =
    (hasACTAndOtherLicenses || !hasOnlyACTLegacyLicenses) &&
    !isTakingOrReviewingTestOrLesson &&
    !location.pathname.includes("/manage/licenses") &&
    !location.pathname.includes("/manage/content") &&
    !location.pathname.includes("/profile") &&
    !location.pathname.includes("/snap/author") &&
    !location.pathname.includes("/context-help-manager") &&
    !location.pathname.includes("/ebooks") &&
    !location.pathname.includes("/demo")

  const goToCurrentVersionHandler = () => {
    if (user.role === Roles.Student) {
      history.push("/student-experience")
    } else {
      history.push("/reporting")
    }
  }

  if (!showPreviousVersionBanner) {
    return null
  }

  return (
    <TopBanner
      text="You are viewing the previous version of the MasteryPrep platform."
      buttonName="Go to Current Version"
      buttonStartIcon="square-arrow-up-right"
      onButtonClick={goToCurrentVersionHandler}
    />
  )
}

export default GoToCurrentVersionBannerContainer
